// REMOVED: loadAdobeAnalytics() - AEP Data Collection embed code handles this.
// REMOVED: eventVariablesMap & propVariablesMap - Their logic moves to AEP Data Collection UI.

import { fetchUserDetails, trackRefModule } from "../helpers";

const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

// Global Data Layer Object
if (typeof window !== 'undefined') {
  window.appEventData = window.appEventData || [];
}

// This function now *populates the data layer* and *triggers AEP Data Collection events*
function isMobileBrowser() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function getPlatformType() {
  if (navigator.userAgentData) {
  navigator.userAgentData.getHighEntropyValues(['platform', 'model', 'mobile'])
    .then(ua => {
      if (ua.mobile) {
        return "Mobile";
      } else {
        return "PC";
      }
    });
}

if (isMobileBrowser()) {
  return "Mobile";
} else {
  return "PC";
}
}

function getFormattedData(ms) {
    const now = ms ? new Date(ms * 1000) : new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    return `${month}/${dd}/${year}`
}

const networks = ['cnbc', 'e', 'msnbc', 'oxygen-true-crime', 'oxygen', 'peacock', 'syfy', 'usa-network', 'golfchannel']
export async function pushAdobeAnalyticsData({ eventName, config }) {
  let isAdobeEnabled = window?.app_data?.appcmsPlatform?.analytics?.adobeConfig?.enabled
  if (!isAdobeEnabled) return 
  let type = config?.type;
  let status = config?.status || null;

  if (!Array.isArray(window.appEventData)) {
    window.appEventData = [];
  }

  const now = new Date();
  const min = now.getMinutes().toString().padStart(2, '0');
  const hrs = now.getHours().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const year = now.getFullYear();
  let referer = trackRefModule("get");
  const pathname = window.location.pathname || '/'
  const pathSegments = pathname.split('/')
  const matchedNetwork = networks.find(network => pathSegments.includes(network)) || null
  const eventData = {
    event: eventName.includes('Provider Sign-In:') ? 'Provider Sign-In' : eventName,
    app: window?.app_data?.site?.siteInternalName,
    platform: getPlatformType(),
    minute: `${hrs}:${min}`,
    hour: `${hrs}:00`,
    day: dayNames[now.getDay()],
    date: `${month}/${day}/${year}`,
    pageName: eventName.includes('Provider Sign-In:') ? eventName : window?.pageTree,
    url: window?.location?.href,
    network: matchedNetwork || "N/A",
    title : window?.pageTree
  };

  if(pathSegments.includes('sports')) {
    eventData.contenthub = 'sports'
  }

  if (config?.customEvent) {
    eventData[config.customEvent.key] = config.customEvent.value;
  }

  const { user } = await fetchUserDetails();

  const success = status === "success";

  if (config?.tveUserId || user?.tveMetadata?.tveUserId) eventData.passguid = user?.tveMetadata?.tveUserId || config?.tveUserId;
  if (type === "TVE") {
    eventData.title = eventName;
    eventData.pageName = eventName;
    if (config?.network) eventData.network = config.network;
    if (status === "success" || status === "fail") {
      eventData.passauthorize = success ? "Authorized" : "Not Authorized";
      if (!success) eventData.fail = config?.authZError;
    }
    if (status === "authn") {
      if (config?.authorizationStatus) {
        eventData.passauthen = config.authorizationStatus;
      }
    }
    eventData.contenthub = "Adobe Pass";
    eventData.passnetwork = window?.app_data?.appcmsPlatform?.tveSettings?.requestorID;
    if (config?.mvpdIdentifier) eventData.passmvpd = config.mvpdIdentifier;
  } 
  else if (type === "SHOWS") {
    if (referer) eventData.module = referer;
    if (config?.network) eventData.network = config.network;
    eventData.contenthub = "SHOWS";
    eventData.episodetitle =  "N/A";
    eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    eventData.season = "N/A";
    eventData.epnumber = "N/A";
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  } 
  else if (type === "SERIES") {
    if (referer) eventData.module = referer;
    if (config?.network) eventData.network = config.network;
    eventData.contenthub = "SERIES";
    eventData.program = config.title;
    eventData.episodetitle = "N/A";
    eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  } 
  else if (type === "SERIES:VIDEO DETAILS") {
    if (referer) eventData.module = referer;
    if (config?.network) eventData.network = config.network;
    eventData.contenthub = "SERIES";
    eventData.program = config?.seriesName;
    eventData.episodetitle = config.title;
    eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    eventData.videoid = config.videoData?.videoId;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }

  const videoPlayerEvents = ["VIDEO PLAYER", "LINEAR VIDEO PLAYER", "LIVE VIDEO PLAYER"];
  const endCardsEvents = [
    "VIDEO PLAYER:END CARD",
    "VIDEO PLAYER:END CARD:USER PROMPT",
    "VIDEO PLAYER:END CARD:NO USER PROMPT",
    "VIDEO PLAYER:END CARD:CLOSE"
  ];

  if (videoPlayerEvents.includes(type)) {
    eventData.length = config.videoData?.videoLength || 86400;
    eventData.videocontent = config.videoData?.contentType;
    eventData.videostatus = config.entitlementStatus;
    eventData.title = type;
    eventData.contenthub = "VIDEO PLAYER";
    eventData.program = config.title;
    eventData.episodetitle = config.title;
    eventData.videoid = config.videoData?.videoId;
    if (config?.network) eventData.network = config.network;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }

  if (endCardsEvents.includes(type)) {
    if (type === "VIDEO PLAYER:END CARD") {
      eventData.title = "VIDEO PLAYER:END CARD";
    } else {
      if (config.currentVideoTime) eventData.endcardcue = config.currentVideoTime;
    }
    eventData.length = config.videoData?.videoLength || 0;
    eventData.videocontent = config.videoData?.contentType;
    eventData.videostatus = config.entitlementStatus;
    eventData.contenthub = "VIDEO PLAYER";
    eventData.program = config.title;
    eventData.episodetitle = config.title;
    eventData.videoid = config.videoData?.videoId;
    eventData.endcardtype = config.endCardType || "unknown";
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }

  if(config?.videoData?.contentType === "LINEARCHANNEL") {
    eventData.episodetitle = window?.lcProgrammeName || config?.title
    eventData.program = window?.lcProgrammeName || config?.title
  }
  
  if (type === "SEARCH") {
    eventData.title = `SEARCH`;
    eventData.contenthub = "SEARCH";
    eventData.searchterm = config?.searchKeyword;
  }

  if (type === "SEARCH:SEARCH RESULTS") {
    eventData.title = `SEARCH:SEARCH RESULTS`;
    eventData.contenthub = "SEARCH";
    eventData.searchterm = config.searchKeyword;
  }

  if(type === "SLE") {
    eventData.contenthub = config.contenthub;
    eventData.sport = config.sport;
    eventData.league = config.league;
    eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    eventData.program = config.title;
    eventData.videoid = config.videoData?.videoId;
    eventData.length = config.videoData?.videoLength
    if (config?.network) eventData.network = config.network;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }
  window.appEventData.push(eventData);
  console.log("Data Layer State: appEventData", window.appEventData);
  return eventData;
}


// REMOVED: trackAdobePageView() and trackAdobeEvent() - Replaced by AEP Data Collection rules.

  export function trackAdobeExtentionCustomEvents(event,payload) {
    // Trigger AEP Data Collection custom event
    if (typeof _satellite !== 'undefined' && _satellite.track) {
      _satellite.track(event,{...payload});
    }
  }
